// In-memory mirror of the current user. Source of truth is /api/me (cookie).
// We keep this around so non-query components (header, share card name, etc.)
// don't all need their own useQuery subscription.

import { create } from 'zustand'
import type { PublicUser } from '@skena/schema'

interface AuthStore {
  user: PublicUser | null
  setUser: (user: PublicUser | null) => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}))
